
export enum ExpenseStatus {
  PAID = 'Pago',
  PENDING = 'Pendente',
  LATE = 'Atrasado',
}

export enum Recurrence {
  NONE = 'Nenhuma',
  WEEKLY = 'Semanal',
  MONTHLY = 'Mensal',
  YEARLY = 'Anual',
}

export type TransactionType = 'income' | 'expense';

export interface User {
  id: string;
  name: string;
  email: string;
  avatarUrl?: string;
  monthlyBudget: number;
  darkMode?: boolean;
}

export interface Category {
  id: string;
  name: string;
  icon: string; // Lucide icon name
  color: string;
  budgetLimit: number;
  alertEnabled?: boolean; // New field for 80% threshold alert
}

export interface Expense {
  id: string;
  description: string;
  amount: number;
  date: string; // ISO String
  categoryId: string | null; // Nullable for Income
  status: ExpenseStatus;
  recurrence: Recurrence;
  paidByUserId: string;
  groupId?: string;
  splitEqually: boolean;
  receiptUrl?: string; // Placeholder for file logic
  type: TransactionType;
  isRecurringInstance?: boolean; // Visual flag for projected expenses
  excludeDates?: string[]; // Dates (YYYY-MM-DD) to skip in recurrence
  originalExpenseId?: string; // If this is a projected instance, this holds the parent DB ID
  isFavorite?: boolean;
}

export interface Group {
  id: string;
  name: string;
  members: User[];
  description?: string;
  inviteCode?: string;
  createdBy: string;
}

export type Tab = 'dashboard' | 'expenses' | 'groups' | 'profile' | 'notifications';